import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function RankingSection() {
  const rankedComics = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 8);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14 bg-background-100/70 rounded-2xl my-6">
      <div className="mb-6">
        <h2 className="text-lg md:text-xl font-bold text-foreground-950">
          排行榜
        </h2>
        <p className="text-sm text-foreground-500 mt-1">
          女神漫画下拉式全集 · 高分好评漫画排行
        </p>
      </div>
      <div className="space-y-3">
        {rankedComics.map((comic, index) => (
          <Link
            key={comic.id}
            to={`/article/${comic.id}`}
            className="flex items-center gap-4 p-3 rounded-lg hover:bg-background-50 transition-colors cursor-pointer group"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <div
              className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold ${
                index === 0
                  ? 'bg-amber-500 text-white'
                  : index === 1
                    ? 'bg-secondary-400 text-white'
                    : index === 2
                      ? 'bg-accent-500 text-white'
                      : 'bg-background-200 text-foreground-500'
              }`}
            >
              {index + 1}
            </div>
            <div className="w-12 h-16 rounded overflow-hidden flex-shrink-0 bg-background-100">
              <img
                src={comic.coverImage}
                alt={comic.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
                {comic.title}
              </h4>
              <p className="text-xs text-foreground-500 mt-0.5">
                {comic.author} · {comic.category}
              </p>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-500 flex-shrink-0">
              <span className="text-xs text-amber-500">
                <i className="ri-star-fill text-[10px]"></i> {comic.rating}
              </span>
              <span className="hidden sm:inline text-xs">
                {(comic.views / 10000).toFixed(0)}万阅读
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}